import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home/Home';
import './appStyle.scss'
import { Authenticator } from '@aws-amplify/ui-react';

import '../src/Pages/Login/Login.scss';


const App = ({ signOut, user }) => {

  const components = {
    Header() {
      return (
        <></>
      );
    },
    Footer() {

      return (
        <></>
      );
    },
    SignIn: {
      Header() {
        return (
          <div className="logo-container">
          </div>
        );
      },
      Footer() {
        return (
          <></>
        );
      },
    },
  };

  const formFields = {
    signIn: {
      username: {
        label: '',
        placeholder: 'Email',
      },
      password: {
        label: '',
        placeholder: 'Password',
      },
    },
  };

  return (
    <Authenticator hideSignUp formFields={formFields} components={components}>
      {({ signOut, user }) => (
        <Router>
          <Routes>
            <Route path="/" element={<Home signOut={signOut} user={user} />} />
          </Routes>
        </Router>
      )}
    </Authenticator>
  );
};

export default App;
